var getUrlQuery		= require('../helpers/getUrlQuery');

function clickHandler(e) {
	var e = e || window.event,
		whatSeason = getUrlQuery()["season"],
		target = e.target || e.srcElement;

	if(target.className === 'camera-link') {

		var cameraLink;
		
		if(whatSeason && typeof whatSeason !== 'undefined' && whatSeason == 'summer') {

			cameraLink = document.querySelector('.summer-cam');
	
		} else if(whatSeason && typeof whatSeason !== 'undefined' && whatSeason == 'winter') {

			cameraLink = document.querySelector('.winter-cam');

		} else if(whatSeason === undefined) {

			$body = document.getElementsByTagName('body')[0];

			if($body.getAttribute('data-season') == 'summer') {

				cameraLink = document.querySelector('.summer-cam');

			} else if($body.getAttribute('data-season') == 'winter') {

				cameraLink = document.querySelector('.winter-cam');

			}

		}

		var cameraAttr = cameraLink.getAttribute('href');

		this.setAttribute('href', cameraAttr);

	}
};

module.exports = clickHandler;